import {IPerson} from "@shared/integrations/taf-api/v2/models";
import PreviousOccupation from "@my-pages/features/employment/components/Occupation/PreviousOccupation.tsx";
import UpComingOccupation from "@my-pages/features/employment/components/Occupation/UpComingOccupation.tsx";
import CurrentOccupation from "@my-pages/features/employment/components/Occupation/CurrentOccupation.tsx";
import ToggleEmploymentFormButton from "@my-pages/features/employment/components/ToggleEmploymentFormButton.tsx";

interface IEmploymentCardProps {
    person?: IPerson;
    onClickChange: () => void;
}

const OccupationStatuses = ({ person, onClickChange }: IEmploymentCardProps) => {
    return (
        <div className='card card-body mb-4'>
            <div className='row'>
                <div className='col-md-12'>
                    <h3>Yrkesstatus</h3>
                    <div
                        className='row'
                        style={{ rowGap: '1.5rem' }}
                    >
                        {person?.previousOccupationalStatuses && person.previousOccupationalStatuses[0] && (
                            <div className='col-12 col-md-4'>
                                <PreviousOccupation occupationStatus={person.previousOccupationalStatuses[0]} />
                            </div>
                        )}
                        {person?.occupationalStatuses && person.occupationalStatuses[0] && (
                            <div className='col-12 col-md-4'>
                                <CurrentOccupation occupationStatus={person.occupationalStatuses[0]} />
                            </div>
                        )}
                        {person?.upcomingOccupationalStatuses && person.upcomingOccupationalStatuses[0] && (
                            <div className='col-12 col-md-4'>
                                <UpComingOccupation occupationStatus={person.upcomingOccupationalStatuses[0]} />
                            </div>
                        )}
                    </div>
                </div>
                <div className='col-md-12'>
                    <ToggleEmploymentFormButton onClickChange={onClickChange} />
                </div>
            </div>
        </div>
    );
};

export default OccupationStatuses;
